export default __webpack_public_path__ + "static/media/profile_pic.60263554.png";